(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('QuestionAnswerDialogController', QuestionAnswerDialogController);

    QuestionAnswerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'QuestionAnswer', 'Runner', 'RaceQuestion'];

    function QuestionAnswerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, QuestionAnswer, Runner, RaceQuestion) {
        var vm = this;

        vm.questionAnswer = entity;
        vm.clear = clear;
        vm.save = save;
        vm.runners = Runner.query({filter: 'questionanswer-is-null'});
        $q.all([vm.questionAnswer.$promise, vm.runners.$promise]).then(function() {
            if (!vm.questionAnswer.runner || !vm.questionAnswer.runner.id) {
                return $q.reject();
            }
            return Runner.get({id : vm.questionAnswer.runner.id}).$promise;
        }).then(function(runner) {
            vm.runners.push(runner);
        });
        vm.racequestions = RaceQuestion.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.questionAnswer.id !== null) {
                QuestionAnswer.update(vm.questionAnswer, onSaveSuccess, onSaveError);
            } else {
                QuestionAnswer.save(vm.questionAnswer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('liverunApp:questionAnswerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
